var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSolidLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.625 6.6875V4.9375C2.625 3.77718 3.08594 2.66438 3.90641 1.84391C4.72688 1.02344 5.83968 0.5625 7 0.5625C8.16032 0.5625 9.27312 1.02344 10.0936 1.84391C10.9141 2.66438 11.375 3.77718 11.375 4.9375V6.6875C11.8391 6.6875 12.2842 6.87187 12.6124 7.20006C12.9406 7.52825 13.125 7.97337 13.125 8.4375V12.8125C13.125 13.2766 12.9406 13.7217 12.6124 14.0499C12.2842 14.3781 11.8391 14.5625 11.375 14.5625H2.625C2.16087 14.5625 1.71575 14.3781 1.38756 14.0499C1.05937 13.7217 0.875 13.2766 0.875 12.8125V8.4375C0.875 7.97337 1.05937 7.52825 1.38756 7.20006C1.71575 6.87187 2.16087 6.6875 2.625 6.6875ZM9.625 4.9375V6.6875H4.375V4.9375C4.375 4.24131 4.65156 3.57363 5.14385 3.08134C5.63613 2.58906 6.30381 2.3125 7 2.3125C7.69619 2.3125 8.36387 2.58906 8.85616 3.08134C9.34844 3.57363 9.625 4.24131 9.625 4.9375Z",
    fill: "#AEB5BC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSolidLock);
export default __webpack_public_path__ + "static/media/icon-solid-lock.352f33d2.svg";
export { ForwardRef as ReactComponent };